/**
 * Anchor's BorshInstructionCoder.encode allocates a 1000-byte buffer
 * (`Buffer.alloc(1000)` with a TODO in the library). Chainlink full reports
 * plus create_game args exceed that and throw `RangeError: encoding overruns Buffer`.
 */
const EXPANDED_IX_BUFFER = 8192
const PATCHED = Symbol('xyroExpandedIxBuffer')

type IxEncoder = {
  discriminator: number[] | Uint8Array
  layout: { encode: (ix: object, buf: Buffer) => number }
}

type InstructionCoderLike = {
  encode: (ixName: string, ix: object) => Buffer
  ixLayouts: Map<string, IxEncoder>
  [PATCHED]?: boolean
}

export function expandInstructionEncodeBuffer(program: {
  coder: { instruction: unknown }
}): void {
  const coder = program.coder.instruction as InstructionCoderLike
  if (coder[PATCHED]) return

  coder.encode = (ixName, ix) => {
    const encoder = coder.ixLayouts.get(ixName)
    if (!encoder) {
      throw new Error(`Unknown method: ${ixName}`)
    }
    const buffer = Buffer.alloc(EXPANDED_IX_BUFFER)
    const len = encoder.layout.encode(ix, buffer)
    return Buffer.concat([
      Buffer.from(encoder.discriminator),
      buffer.subarray(0, len)
    ])
  }
  coder[PATCHED] = true
}
